export default __webpack_public_path__ + "static/media/cp_geo_mu.24a97352.svg";